import React, { useRef, useEffect } from 'react';

declare global {
  interface Window {
    turnstile?: any;
  }
}

interface CloudflareTurnstileProps {
  siteKey: string;
  onSuccess: (token: string) => void;
}

const CloudflareTurnstile: React.FC<CloudflareTurnstileProps> = ({ siteKey, onSuccess }) => {
  const widgetRef = useRef<HTMLDivElement>(null);
  const turnstileWidgetId = useRef<string | null>(null);

  useEffect(() => {
    if (!window.turnstile) {
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
      script.async = true;
      document.body.appendChild(script);
      script.onload = () => {
        renderTurnstile();
      };
    } else {
      renderTurnstile();
    }
    // Cleanup
    return () => {
      if (turnstileWidgetId.current && window.turnstile) {
        window.turnstile.remove(turnstileWidgetId.current);
      }
    };
    // eslint-disable-next-line
  }, []);

  const renderTurnstile = () => {
    if (window.turnstile && widgetRef.current) {
      turnstileWidgetId.current = window.turnstile.render(widgetRef.current, {
        sitekey: siteKey,
        callback: (token: string) => {
          onSuccess(token);
        },
      });
    }
  };

  return <div ref={widgetRef} />;
};

export default CloudflareTurnstile;
